import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
import { ReportfilterComponent } from '../../grid/reportfilter/reportfilter.component';
@Component({
  selector: 'app-inoutpunchdetailsreport',
  templateUrl: './inoutpunchdetailsreport.component.html',
  styleUrls: ['./inoutpunchdetailsreport.component.css']
})
export class InoutpunchdetailsreportComponent implements OnInit {

  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  formname: string = "InoutPunchDetailsReport";

  filteremployeeid: any = 0;
  filteremployeename: any = "";
  filterfromdate: any = new Date();
  filtertodate: any = new Date();

  filterstatus: string = "";
  dtOptions: DataTables.Settings = {};

  inoutpunchdetColl: any = [];
  empColl: any = [];




  searchtxt: any = "";

  columnDefs = [
    { headerName: 'Employee', field: 'empname' },
    { headerName: 'In Time', field: 'intime' },
    { headerName: 'Out Time', field: 'outtime' },
    { headerName: 'Work Min', field: 'workmin' },
    { headerName: 'Late Min', field: 'latemin' },
    { headerName: 'Early Min', field: 'earlymin' },

  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  };

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal, private toastr: ToastrService, private datePipe: DatePipe) {
    this.fnGetParameterVariable();
    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
    this.filterfromdate.setDate(this.filterfromdate.getDate() - 15);
  }

  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }
      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }
      if (params.fromdate !== undefined) {
        console.log(params.fromdate)
        console.log(this.fnConvertDatetime(params.fromdate))
        console.log(this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate)))
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        console.log(params.todate)
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
    })
  }

  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  //Init
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fngetInoutPunchDetailsReport();
    this.fngetEmp();
  }


  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }





  fnActionExportClick() {
    const params = {
      columnGroups: true,
      allColumns: true,
      fileName: 'payadvlist',
      //columnSeparator: document.querySelector("#columnSeparator").value
    };

  }


  fnActionRefreshClick() {
    this.fngetInoutPunchDetailsReport()
    //  this.fngetEmp();
  }

  fnApplyFilter(data) {
    //this.isfilter = !this.isfilter;

    this.filterstatus = data;

    this.fngetInoutPunchDetailsReport();

  }
  fnActionFilterClick() {

    // this.filterbar.filterstatus = this.filterstatus;

    // this.isfilter = !this.isfilter;
    this.fnShowFilterPopup()
  }
  fnApplyFilterPop(data) {
    // this.isfilter = !this.isfilter;

    this.filterstatus = data;
    this.filteremployeeid = data.empid;
    this.filteremployeename = data.empname;


    this.fngetInoutPunchDetailsReport();

  }


  fnCurrentRouteChange() {
    var queryParams = {};


    if (this.filterstatus != '') {
      queryParams['status'] = this.filterstatus;
    }

    if (this.filteremployeeid > 0) {
      queryParams['empid'] = this.filteremployeeid;
    }
    if (this.filteremployeename != '') {
      queryParams['empname'] = this.filteremployeename;
    }
    if (this.filterfromdate != '') {
      queryParams['fromdate'] = this.fnFormatDatetime(this.filterfromdate);
    }
    if (this.filtertodate != '') {
      queryParams['todate'] = this.fnFormatDatetime(this.filtertodate);
    }

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }

  fnRemoveFilter(type) {

    if (type === 'INACTIVE') {
      this.filterstatus = "";
      this.fngetInoutPunchDetailsReport();
    }
    else {
      this.filterstatus = "";
      this.fngetInoutPunchDetailsReport();
    }
  }

  //Get
  fngetEmp() {
    var data = {
      'empid': this.filteremployeeid,
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.empColl = res.json().result;

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  //Get
  fngetInoutPunchDetailsReport() {
    if (this.showProgress) {
      return;
    }

    this.fnShowProgress();
    var data = {

      'companyid': this.loginService.fnGetCompanyId(),
      'empid': this.filteremployeeid,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
    }
    this.appService.getInoutPunchDetailsReport(data)
      .subscribe(
        (res) => {
          console.log(res)
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.inoutpunchdetColl = res.json().result;
            console.log(this.inoutpunchdetColl)
            this.fnSetTable();
            this.fnCurrentRouteChange();

          } else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }






  fnSetTable() {

  }
  public fnSearchDatatable(value) {

  }

  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.inoutpunchdetColl[index].hoverfocus = "IN"
      }
      else {
        this.inoutpunchdetColl[index].hoverfocus = ""
      }
    }
  }

  fnShowFilterPopup() {

    const modalRef = this.productFindService.open(ReportfilterComponent, { size: <any>'xl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.empid = Number(this.filteremployeeid);
    // modalRef.componentInstance.fromdate = this.filterfromdate;
    // modalRef.componentInstance.todate = this.filtertodate;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      console.log(receivedEntry)

      if (receivedEntry.status === 'DONE') {
        this.filteremployeeid = receivedEntry.empid;
        this.filteremployeename = receivedEntry.empname;

        this.fngetInoutPunchDetailsReport();
      }


    });
  }



  fnFormatDecimal(params) {
    if (params.value) {
      return params.value.toFixed(2)
    }
  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }
  }
  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }

  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }

  private fnExport() {

    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.inoutpunchdetColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });

  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  fnCloseForm() {
    try {
      this.router.navigate(['/Reports']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }








}

